import React, { useState, useEffect } from 'react';
import { Collapse, Checkbox, Divider } from 'antd';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import BasicPopconfirm from '../../../containers/popconfirms/basic_popconfirm';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import Icon from '@mui/material/Icon';
import ScaleIcon from '@mui/icons-material/Scale';
import PercentIcon from '@mui/icons-material/Percent';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { format, parseISO } from 'date-fns';

const { Panel } = Collapse;

const CrudeBoxList = (props) => {

  const build_check_process = (order) => {
    return (
      <Checkbox
        style={{ marginRight: '15px' }}
        checked={order ? (order.checked === 1 ? true : false) : false}
        onClick={(event) => {
          event.stopPropagation();
        }}
        onChange={() => {
          props.updateDataOrdersChecked(order);
        }}
      ></Checkbox>
    );
  };

  const build_percent_client = (order) => {
    return (
      <IconButton color="primary" onClick={(e) => {
        e.stopPropagation()
        props.updateClientPercent(order);
      }}>
        <PercentIcon />
      </IconButton>
    );
  };


  const genExtra = (order) => {
    return (
      <div>

        <IconButton
          style={{ marginRight: '10px' }}
          color='primary'
          aria-label='pdf'
          onClick={(e) => {
            e.stopPropagation();
            props.displayPDF(order);
          }}
        >
          <PictureAsPdfIcon />
        </IconButton>
        {build_percent_client(order)}
        {build_check_process(order)}



      </div>
    );
  };

  const roundTwo = (value) => {
    return Number(value).toFixed(4);
  }

  const getLatestOrderDetailCrudeDate = (ordersDetail) => {
    if(! ordersDetail) return null;
    if(ordersDetail.length === 0) return null;
    const filtered = ordersDetail.filter((detail) => detail.fecha_crudo !== undefined && detail.fecha_crudo !== null);
    if(filtered.length === 0) return null;
    const ordered = filtered.sort((a, b) => a.fecha_crudo < b.fecha_crudo ? -1 : 1);
    return ordered[0].fecha_crudo;
  }

  const getCrudeDate = (crudeDate) => {
    if(!crudeDate) return 'Sin Fecha';

    return format(new Date(crudeDate), 'dd-MM-yyyy HH:mm:ss')
  }

  const buildPanel = (d, key, filterFunc) => {

    return (
      <Panel
        style={{ backgroundColor: '#DFFFD9', fontWeight: 'normal' }}
        key={key + 1}
        extra={genExtra(d)}
        header={
          <>
            <strong style={{ marginRight: '20px', fontSize: '0.7em' }}>{`Orden: ${d.id}`}</strong>
            <strong style={{ fontSize: '0.7em' }}>{`Cliente: ${d.ordersDetail.length > 0 ? d.ordersDetail[0].productPrice ? d.ordersDetail[0].productPrice.client ? d.ordersDetail[0].productPrice.client.name : '' : '' : ''}`}</strong>
            <Chip style={{ marginLeft: '20px', fontSize: '0.7em' }} label={`Entró: ${getCrudeDate(getLatestOrderDetailCrudeDate(d.ordersDetail))}`} size='small' color="primary" variant="outlined" />
            <Chip style={{ marginLeft: '20px', fontSize: '0.7em' }} label={`Entrega: ${d.date_delivery ? format(parseISO(d.date_delivery), 'dd-MM-yyyy HH:mm:ss') : 'INMEDIATA'}`} size='small' color="warning" variant="outlined" />
          </>
        }
      >
        {
          <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
              <span style={{ fontSize: '12px', fontWeight: 'bold' }}>
                Dirección de envío: {d.address_delivery}
              </span>
            </Grid>
            <Divider style={{ marginTop: '-1px', marginBottom: '-10px' }} />
            <Grid container spacing={1}>
              <Grid item xs={2} md={2}>
                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                  Producto
                </span>
              </Grid>
              <Grid item xs={2} md={2}>
                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                  Color
                </span>
              </Grid>
              <Grid item xs={1} md={1}>
                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                  Máq.
                </span>
              </Grid>
              <Grid item xs={1} md={1}>
                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                  KG
                </span>
              </Grid>
              <Grid item xs={1} md={1}>
                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                  MTS
                </span>
              </Grid>
              <Grid item xs={2} md={2}>
                <span style={{ fontSize: '10px', fontWeight: 'bold' }}>
                  Proceso Asignado
                </span>
              </Grid>


            </Grid>
            {
              d.ordersDetail.filter(filterFunc).map((od, key) => {
                return (
                  <Grid key={key + 'itemOd'} container spacing={1}>
                    <Grid item xs={2} md={2}>
                      <span style={{ fontSize: '10px', fontFamily: 'monospace', color : od.ready ? 'green' : 'red' }} >
                        {od.productPrice ? (od.productPrice.product ? od.productPrice.product.ref : '') : ''}
                      </span>

                    </Grid>
                    <Grid item xs={2} md={2}>
                      <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                        {od.color ? od.color.cod : ''}
                      </span>
                    </Grid>
                    <Grid item xs={1} md={1}>
                      <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                        {od.formulas ? typeof od.formulas === 'object' ? od.formulas.machine : '' : ''}
                      </span>
                    </Grid>
                    {/*Columna de kilos */}
                    {od.type_quantity === 'KG' ?
                      <Grid item xs={1} md={1}>
                        <span style={{ fontSize: '10px', fontFamily: 'monospace', color: 'blue' }}>
                          {od.quantity ?
                            od.productPrice.client.clientPercent.length > 0 ?

                              od.quantity +
                              ((od.productPrice.client.clientPercent[0].percent * od.quantity) / 100)

                              :
                              od.quantity +
                              ((props.defectPercent * od.quantity) / 100)
                            :
                            'N.A'
                          }
                        </span>
                      </Grid>

                      :
                      <Grid item xs={1} md={1}>
                        <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                          {od.productPrice.product.productWeight.length > 0 ?
                            od.productPrice.client.clientPercent.length > 0 ?
                              roundTwo(((od.quantity * od.productPrice.product.productWeight[0].kilo) / od.productPrice.product.productWeight[0].meter) +
                                ((od.quantity * od.productPrice.product.productWeight[0].kilo) / od.productPrice.product.productWeight[0].meter * od.productPrice.client.clientPercent[0].percent) / 100)
                              :
                              roundTwo(((od.quantity * od.productPrice.product.productWeight[0].kilo) / od.productPrice.product.productWeight[0].meter) +
                                ((od.quantity * od.productPrice.product.productWeight[0].kilo) / od.productPrice.product.productWeight[0].meter * props.defectPercent) / 100)
                            :
                            'N.A'
                          }
                        </span>
                      </Grid>

                    }
                    {/*Columna de metros */}
                    {od.type_quantity === 'MTS' ?

                      <Grid item xs={1} md={1}>
                        <span style={{ fontSize: '10px', fontFamily: 'monospace', color: 'blue' }}>
                          {od.quantity ? od.quantity : ''}
                        </span>
                      </Grid>

                      :
                      <Grid item xs={1} md={1}>
                        <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                          {od.productPrice.product.productWeight.length > 0 ?
                            (od.quantity * od.productPrice.product.productWeight[0].meter) / od.productPrice.product.productWeight[0].kilo
                            :
                            'N.A'
                          }
                        </span>
                      </Grid>

                    }


                    <Grid item xs={2} md={2}>
                      <div style={{ fontSize: '0.5em' }}>{getCrudeDate(od.fecha_crudo)}</div>
                      <span style={{ fontSize: '10px', fontFamily: 'monospace' }}>
                        {od.cod_process ? od.cod_process : ''}
                      </span>
                    </Grid>

                    <Grid item xs={2} md={2}>
                      <span style={{ fontSize: '9px' }}>
                        <BasicPopconfirm
                          label='Eliminar orden'
                          title='¿Seguro/a que deseas eliminar este producto?'
                          onConfirm={() => { props.deleteOrderDetail(od) }}
                          button={
                            <IconButton color="error" aria-label="delete" onClick={(e) => e.stopPropagation()}>
                              <DeleteIcon />
                            </IconButton>
                          }
                        />
                      </span>
                      <span style={{ fontSize: '9px' }}>
                        <IconButton size='small' onClick={() => { props.viewColor(od); }}>
                          <Icon>color_lens</Icon>
                        </IconButton>
                      </span>
                      <span style={{ fontSize: '9px' }}>
                        <IconButton size='small' onClick={() => { props.viewQR(od, d.uuid); }}>
                          <Icon>qr_code</Icon>
                        </IconButton>
                      </span>
                      <span style={{ fontSize: '9px' }}>
                        <IconButton size='small' onClick={() => { props.setEditOrder(od, d); }}>
                          <Icon>content_cut</Icon>
                        </IconButton>
                      </span>
                      <span style={{ fontSize: '9px' }}>
                        <BasicPopconfirm
                          label='Eliminar orden'
                          title='¿Seguro/a que quieres re-agrupar los recortes?'
                          onConfirm={() => { props.regroup(od, d) }}
                          button={
                            <IconButton size='small' onClick={(e) => e.stopPropagation()}>
                              <Icon>undo</Icon>
                            </IconButton>
                          }
                        />
                      </span>
                      <span style={{ fontSize: '9px' }}>
                        <BasicPopconfirm
                          label='Eliminar orden'
                          title='¿Seguro/a que lo imprimiste y quieres dejarlo en bandeja de IMPRESOS?'
                          onConfirm={() => { props.readyOrderDetail(od) }}
                          button={
                            <IconButton size='small' onClick={(e) => e.stopPropagation()}>
                              <Icon>check</Icon>
                            </IconButton>
                          }
                        />
                      </span>
                      <span style={{ fontSize: '9px' }}>
                        <select
                          key={od.uuid}
                          style={{ fontSize: '13px', padding: '2px' }}
                          data-uuid={od.uuid}
                        >
                          {
                            props.process.filter((p) => p.cod !== 'ALIM').map((obj) =>

                              <option
                                key={`${obj.cod}//${d.uuid}//${od.uuid}//${od.color.cod}`}
                                value={`${obj.cod}//${d.uuid}//${od.uuid}//${od.color.cod}`}
                              >
                                {obj.name}
                              </option>

                            )}
                        </select>
                      </span>

                    </Grid>
                  </Grid>
                )
              })
            }
            <Grid container spacing={1}>
              <Grid item xs={2} md={2}>
              </Grid>
              <Grid item xs={2} md={2}>
              </Grid>
              <Grid item xs={1} md={1}>
              </Grid>
              <Grid item xs={1} md={1}>
              </Grid>
            </Grid>
            <br />
            <Divider style={{ marginTop: '-20px' }} />
            <Grid item xs={12} md={12}>
              <span style={{ fontSize: '12px', fontWeight: 'normal' }}>
                NOTA: {d.notes}
              </span>
            </Grid>
          </Grid>
        }
      </Panel>
    );
  }

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={6}>
        <div style={{ margin: '10px 0', fontSize: '1.1em', fontWeight: 'bold' }}>Pedidos | Items ({props.totalItems}) Metros ({props.totalMeters})</div>
        <Collapse defaultActiveKey={[]} expandIconPosition={'right'}>
          {props.data.map((d) =>
            d.ordersDetail.some((od) => od.cod_process === 'CRUD' && od.cod_process !== 'ALIS') && (
              buildPanel(d, d.uuid, (od) => od.cod_process === 'CRUD')
            )
          )}
        </Collapse>
      </Grid>
      <Grid item xs={12} md={6}>
        <div style={{ margin: '10px 0', fontSize: '1.1em', fontWeight: 'bold' }}>Pedidos Impresos | Items ({props.totalAlisItems}) Metros ({props.totalMetersAlis})</div>
        <Collapse defaultActiveKey={[]} expandIconPosition={'right'}>
          {props.data.map((d) =>
            d.ordersDetail.some((od) => od.cod_process === 'ALIS') && (
              buildPanel(d, d.uuid, (od) => od.cod_process === 'ALIS')
            )
          )}
        </Collapse>
      </Grid>
    </Grid>
  );

};

export default CrudeBoxList;
